// removed by extract-text-webpack-plugin
module.exports = {"container":"footer-module-container-f092428efc180a65708cd8bbbc258118--","wrapper":"footer-module-wrapper-ff80fe1da74df28f04415f5038edad39--","logo":"footer-module-logo-f3101afa92aa85c4bbe2358892a25cff--"};


//////////////////
// WEBPACK FOOTER
// /src/components/footer/footer.module.scss
// module id = 1992
// module chunks = 0